import { FC } from 'react';
import { BsFillTagFill } from 'react-icons/bs';

import { CouponCodeDetailsProps, Styled } from './';

const CouponCodeDetails: FC<CouponCodeDetailsProps> = ({
  promotions,
  hideApplyMessage = false,
}) => {
  return (
    <Styled.Wrapper>
      {hideApplyMessage ? null : 'Applied Coupons'}
      <Styled.AppliedCouponCodeContainer>
        {promotions.map(promo => (
          <Styled.CouponCode>
            <BsFillTagFill size="16px" style={{ color: 'green' }} />
            <Styled.DiscountAmount>{promo.promoCode}</Styled.DiscountAmount>
          </Styled.CouponCode>
        ))}
      </Styled.AppliedCouponCodeContainer>
    </Styled.Wrapper>
  );
};

export default CouponCodeDetails;
